<template>
  <div>
    <a-modal
      width="40%"
      title="驳回原因"
      destroy-on-close
      :visible.sync="visible"
      append-to-body
      ok-text="确认"
      cancel-text="取消"
      @ok="handleOk"
      @cancel="handleCancel"
      :footer="null"
    >
      {{ reasonText }}
    </a-modal>
  </div>
</template>
<script>
export default {
  name: "",
  data() {
    return {
      visible: false,
      reasonText: "",
    };
  },
  methods: {
    init(reasonText) {
      this.visible = true;
      this.reasonText = reasonText;
    },
    handleOk() {
      this.visible = false;
      this.reasonText = "";
    },
    handleCancel() {
      this.visible = false;
      this.reasonText = "";
    },
  },
  mounted() {},
};
</script>

<style scoped lang="scss">
</style>